import styleFns, {compose} from '../util'

const boxShadow = styleFns({propName: 'boxShadow'})
export default compose(boxShadow)
